import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/types/redux';
import { Layout, Header, theme } from '@goalsetter/ant-design-ui';
import { PublicLanguageSelector } from '@goalsetter/classroom-web-app-sdk/i18n';
import { getClientSupportedLocales } from '@goalsetter/classroom-types/academy';
import { useBrandingContext } from '@/contexts';
import {
  layoutStyle,
  headerContainerStyle,
  StyledGradientLayout,
  StyledBreakpointsContainer,
} from './style';

const { useToken } = theme;

interface GradientLayoutProps {
  children: React.ReactNode;
}

function getPublicLocaleSelectorAnchorStyle(padding: number): CSSProperties {
  return {
    position: 'fixed',
    right: padding,
    bottom: padding,
    zIndex: 10,
  };
}

const GradientLayout = ({ children }: GradientLayoutProps) => {
  const { headerProps, backgroundColor } = useSelector(
    (store: RootState) => store.layout,
  );
  const { token } = useToken();
  const { config, isLoaded } = useBrandingContext();
  const locales = getClientSupportedLocales(config?.config);
  return (
    <Layout style={layoutStyle}>
      <div style={headerContainerStyle}>
        {headerProps && <Header {...headerProps} />}
      </div>
      <StyledGradientLayout
        withHeader={!!headerProps}
        background={backgroundColor}
      >
        <StyledBreakpointsContainer breakpointSM={token.screenSM}>
          {children}
        </StyledBreakpointsContainer>
        {isLoaded ? (
          <div style={getPublicLocaleSelectorAnchorStyle(token.padding)}>
            <PublicLanguageSelector locales={locales} />
          </div>
        ) : null}
      </StyledGradientLayout>
    </Layout>
  );
};

export default GradientLayout;
